import type { AdvancedDataTableComponent } from '@shared/components/advanced-data-table/advanced-data-table.component';

/**
 * Opens the column picker for advanced data table (PrimeNG p-button wrapper).
 */
export function openWarehouseTableColumnSelector(
  table: AdvancedDataTableComponent | undefined,
  event: Event,
): void {
  const target = event.target as HTMLElement;
  const pBtn = target.closest('p-button');
  const innerBtn = pBtn?.querySelector('button') as HTMLElement | null;
  const btn =
    innerBtn || (target.closest('button') as HTMLElement) || target;
  if (btn && table) {
    table.openColumnSelector(btn);
  }
}
